import { DeckList } from './behaviors/desk-list.js';
import { Deck } from './behaviors/deck.js';

(() => {
  const deckListElement = document.querySelector('.awk-deck-list');
  if (deckListElement) {
    new DeckList(deckListElement);
  }

  const deck = document.querySelector('.awk-deck__piles');
  if (deck) {
    new Deck(deck);
  }
})();
